import { reatomAsync, withDataAtom } from "@reatom/async";
import { withAbort } from "@reatom/framework";
import { API } from "src/api.ts";
import { withDebounce } from "src/common/pipes";

import { dashboardDateRangeAtom } from "../atom";

export const getOrdersByStatusesRequest = reatomAsync(async (ctx) => {
  const filter = ctx.get(dashboardDateRangeAtom);
  return API.orderApi
    .orderControllerGetOrdersByStatus(filter || {}, {
      signal: ctx.controller.signal,
    })
    .then((response) => response.data);
}, "getOrdersByStatusesRequest").pipe(withDataAtom(null), withAbort());

export const getOrdersByStatusesWithDebouncing =
  getOrdersByStatusesRequest.pipe(withDebounce(200));
